import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);

  useEffect(() => {
    const closeMore = (event) => {
      if (moreRef.current && !moreRef.current.contains(event.target)) {
        setMoreOpen(false);
      }
    };

    document.addEventListener("mousedown", closeMore);
    return () => document.removeEventListener("mousedown", closeMore);
  }, []);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <nav className="header-nav-left">
        <Link to="/shop" onClick={toTop}>
          NEW COLLECTION
        </Link>
        <Link to="/about" onClick={toTop}>
          ABOUT
        </Link>
        <Link to="/contact" onClick={toTop}>
          CONTACT US
        </Link>
        <div className="header-more" ref={moreRef}>
          <button
            type="button"
            aria-expanded={moreOpen}
            aria-controls="header-more-menu"
            onClick={() => setMoreOpen((open) => !open)}
          >
            MORE
            <span aria-hidden="true" className="more-chevron">
              {moreOpen ? "−" : "+"}
            </span>
          </button>
          {moreOpen && (
            <div className="header-more-menu" id="header-more-menu">
              <Link to="/privacy" onClick={toTop}>Privacy</Link>
              <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
              <Link to="/faqs" onClick={toTop}>FAQs</Link>
              <Link to="/terms" onClick={toTop}>Terms</Link>
              <Link to="/shipping" onClick={toTop}>Shipping</Link>
              <Link to="/returns" onClick={toTop}>Returns</Link>
            </div>
          )}
        </div>
      </nav>

      <div className="header-logo">
        <Link to="/" onClick={toTop} aria-label="Shiskerstone home">
          <span className="brand-emblem" aria-hidden="true">S</span>
          <span className="brand-wordmark">SHISKERSTONE</span>
        </Link>
      </div>

      <nav className="header-nav-right">
        <Link to="/cartpage" className="cart-link" onClick={toTop}>
          {`CART (${cartItems ? cartItems.length : 0})`}
        </Link>
      </nav>
    </header>
  );
}

export default Header;
